// removed by extract-text-webpack-plugin
module.exports = {"field":"antd-pro-charts-field-field","label":"antd-pro-charts-field-label","number":"antd-pro-charts-field-number"};


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/src/components/Charts/Field/index.less
// module id = 583
// module chunks = 0